// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VeeValidate from 'vee-validate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueMask from 'v-mask'
import BackToTop from 'vue-backtotop'
import vClickOutside from 'v-click-outside'
import LoadScript from 'vue-plugin-load-script'
import VueCarousel from '@chenfengyuan/vue-carousel'
import VueGlide from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'

Vue.use(VueGlide)
Vue.use(BackToTop)
Vue.use(VueMask)
Vue.use(VueSweetalert2)
Vue.use(VeeValidate)
Vue.use(vClickOutside)
Vue.use(LoadScript)
Vue.component(VueCarousel.name, VueCarousel)


Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  data: {
    cars: [],
    parts: [],
    searchData: '',
    itemsPerPage: 50
  },
  methods: {
    // updateCars (newCars) {
    //   this.cars = newCars
    // },
    // updateParts (newParts) {
    //   this.parts = newParts
    // }
  },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js